import {NgModule} from '@angular/core';
import {NoPreloading, RouterModule, Routes} from '@angular/router';
import {environment} from '../environments/environment';
import {guestGuard, authGuard} from './core/guards/auth.guard';

const routes: Routes = [
  // Landing page (accessible to all, but redirects authenticated users)
  {
    path: 'landing',
    loadChildren: () => import('./pages/landing/landing.module').then(m => m.LandingModule),
    canActivate: [guestGuard], // Redirects to / if authenticated
  },
  // Main app (requires authentication) - redirects to landing if not authenticated
  {
    path: '',
    loadChildren: () => import('./pages/main.module').then(m => m.MainPageModule),
    canActivate: [authGuard], // Redirects to /landing if not authenticated
  },
  {
    path: 'playground',
    loadChildren: () => import('./pages/playground/playground.module').then(m => m.PlaygroundPageModule),
  },
  {
    path: 'benchmark',
    loadChildren: () => import('./pages/benchmark/benchmark.module').then(m => m.BenchmarkPageModule),
  },
  {path: 'about', loadChildren: () => import('./pages/landing/landing.module').then(m => m.LandingModule)},
  {path: 'legal', loadChildren: () => import('./pages/landing/landing.module').then(m => m.LandingModule)},
  {
    path: 'learn',
    loadChildren: () => import('./pages/learn/learn.module').then(m => m.LearnModule),
  },
  {
    path: '**',
    loadChildren: () => import('./pages/not-found/not-found.module').then(m => m.NotFoundPageModule),
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      initialNavigation: environment.initialNavigation,
      preloadingStrategy: NoPreloading,
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
